export default __webpack_public_path__ + "static/media/yenbackLogo.95d6e79c.svg";